export default function (newMessage, oldMessage) {
  const subjectHasChanged = newMessage.subject !== oldMessage.subject;
  const ccHasChanged = newMessage.cc !== oldMessage.cc;
  const bccHasChanged = newMessage.bcc !== oldMessage.bcc;
  const bodyHasChanged = (newMessage.body?.trimEnd() !== oldMessage.body?.trimEnd()) &&
    (newMessage.body?.trimEnd() !== `<span>${oldMessage.body?.trimEnd()}</span>`)

  return bodyHasChanged || subjectHasChanged || ccHasChanged || bccHasChanged;
}
